import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";

let bootPromise = null;

function accessTokenExp(session) {
  const exp = session?.tokens?.accessToken?.payload?.exp;
  return typeof exp === "number" ? exp : null;
}

/**
 * Shared Cognito session bootstrap. Cached until resetAuthBootstrap().
 * @returns {Promise<{ status: 'AUTHENTICATED' | 'UNAUTHENTICATED', hasAccessToken: boolean, accessExp: number | null }>}
 */
export function ensureAuthBootstrapped() {
  if (!bootPromise) {
    bootPromise = (async () => {
      try {
        const session = await fetchAuthSession();
        const hasAccessToken = Boolean(session?.tokens?.accessToken);
        const accessExp = accessTokenExp(session);
        const status = hasAccessToken ? "AUTHENTICATED" : "UNAUTHENTICATED";
        console.warn("[auth] bootstrap_done", {
          status,
          hasAccessToken,
          accessExp,
        });
        return { status, hasAccessToken, accessExp };
      } catch (error) {
        console.warn("[auth] bootstrap_error", {
          name: error?.name,
          message: error?.message,
        });
        return {
          status: "UNAUTHENTICATED",
          hasAccessToken: false,
          accessExp: null,
        };
      }
    })();
  }
  return bootPromise;
}

/**
 * Confirms the user has no usable Cognito session before treating them as logged out.
 */
export async function isTrulyUnauthenticated() {
  try {
    const session = await fetchAuthSession();
    if (!session?.tokens?.accessToken) {
      return true;
    }
    await getCurrentUser();
    return false;
  } catch (error) {
    console.warn("[auth] isTrulyUnauthenticated", {
      name: error?.name,
      message: error?.message,
    });
    return true;
  }
}

export function clearAppAuthState(store) {
  if (!store) return;
  store.commit("CLEAR_AUTH_STATE");
}

export function resetAuthBootstrap() {
  bootPromise = null;
}
